// extracted by mini-css-extract-plugin
module.exports = {"col":"Table_col__j62IJ","checkboxCol":"Table_checkboxCol__QBeGJ","emailCol":"Table_emailCol__35CFh","actionCol":"Table_actionCol__3E_hp"};